import { Route } from "react-router-dom";
import { lazy } from "react";
import ProtectedRoute from "../components/ProtectedRoute";

const DashboardPrincipal = lazy(() => import("../layouts/supervisor/DashboardPrincipal"));

export default function SupervisorRoutes() {
  return (
    <>
      {/* HOME */}
      <Route
        path="/home/supervisor"
        element={
          <ProtectedRoute allowedRoles={["SUPERVISOR"]}>
            <DashboardPrincipal />
          </ProtectedRoute>
        }
      />
    </>
  );
}